<template>
  <list-table
    :url="url"
    title="تراکنش های ریفاند"
    :fields="fields"
    :params="params"
    :isForExcel="true"
  ></list-table>
</template>
<script>
import TableShowData from "../../components/table";
import { GET_USER_LIST } from "@/core/services/store/getUserList.module";
import persianDate from '../../helpers/persianDate';
export default {
  name: "RefundTransactionList",
  data() {
    return {
      url: "~reports/api/admin-refunds",
      fields: [
        {
          key: "transaction_id",
          label: "کد تراکنش برگشت شده",
        },
        {
          key: "created_at",
          label: "تاریخ و ساعت", formatter: (value, key, item) => {
            return persianDate.getDate(item.created_at) + ' ' + persianDate.getTime(item.created_at)
          },
        },
        {
          key: "website_name",
          label: "وب سایت",
         
        },
        {
          key: "card_holder_pan",
          label: "شماره کارت مقصد",
          tdClass:'ltr'
        },
        {
          key: "sale_refrence_id",
          label: "کد رهگیری تراکنش اصلی",
         
        },
        {
          key: "tracking_number",
          label: "کد رهگیری تراکنش برگشت",
         
        },
        {
          key: "amount",
          label: "مبلغ (ریال)",
          tdClass:'ltr',
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "wage",
          label: "کارمزد (ریال)",
          tdClass:'ltr',
          formatter(value, key, item) {
           
            return Number(value).toLocaleString()
          },
        },
      ],
      params: [
        {
          label: "از تاریخ :",
          field: "dateFrom",
          type: "date-picker"
        },
        {
          label: "تا تاریخ:",
          field: "dateTo",
          type: "date-picker"
        },
        {
          label: "سایت:",
          field: "website",
           type: "text"
         
        },
        {
          label: "شماره پیگیری:",
          field: "refundTrackNumber",
          type: "text"
        },
        {
          label: "شماره کارت:",
          field: "cardNumber",
          type: "text"
        }
      ],
     
    };
  },
  components: {
    "list-table": TableShowData,
  },
 computed: {
    loadedUserList() {
      return this.$store.getters.loadedUserList;
    },
  },

  mounted() {
    this.getUserList();
  },
  methods: {
    getUserList() {
      this.$store.dispatch(GET_USER_LIST,'users-with-refund').then((data) => {
        let option = [{ text: "انتخاب نشده", value: null }];
        data.forEach((element) => {
          option.push({ text: element.name, value: element.id });
        });

        this.params[6].options = option;
      });
    },
  },
};
</script>
<style>
.ltr{
  direction: ltr;
}
</style>